module.exports = __webpack_public_path__ + "static/img/chanta (24).c72c050.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (24).jpg
// module id = mbT5
// module chunks = 0